export interface ZipLookup {
  city?: string;
  state?: string; // 2-letter code
  country?: string;
}

// Look up city/state/country for a US zip via the public ZIP service.
// Returns null on invalid zip or any failure.
export const lookupCityStateByZip = async (
  zip: string
): Promise<ZipLookup | null> => {
  if (!/^\d{5}$/.test(zip)) return null;
  try {
    const response = await fetch(`https://zip.getziptastic.com/v2/US/${zip}`);
    if (!response.ok) return null;
    const result = await response.json();
    return {
      city: result.city,
      state: result.state_short,
      country: result.country,
    };
  } catch {
    return null;
  }
};
